module.exports = __webpack_public_path__ + "img/favicon.56873954.png";